<template>
  <div class="container">
    <address-input
      v-for="(plaats, index) in $v.contact.woonplaats.$each.$iter"
      :key="'wp-' + index"
      v-model="contact.woonplaats[index]"
      :id="'plaats-' + index"
      :label="
        contact.woonplaats.length != 1
          ? labels.woonplaats.objectName.singular + ' ' + (parseInt(index) + 1)
          : labels.woonplaats.objectName.singular
      "
      :is-new="index >= cache.woonplaats.length"
      :is-dirty="
        isDiffToCache(
          contact.woonplaats[parseInt(index)],
          cache.woonplaats[parseInt(index)]
        )
      "
      :show-delete="index != 0"
      :info="infoForInput('woonplaats')"
      :is-disabled="disabledFieldsMap.woonplaats"
      @delete-address="deleteWoonplaats(index)"
    >
    </address-input>
    <div class="text-center my-1 pb-3 border-bottom">
      <plus-button
        v-if="hasMaxOneNew(contact.woonplaats, cache.woonplaats)"
        @click="addWoonplaats()"
        :disabled="disabledFieldsMap.woonplaats"
        :label="
          'Bij verhuis: ' +
            labels.woonplaats.objectName.singular.toLowerCase() +
            ' toevoegen'
        "
      >
      </plus-button>
    </div>
    <address-input
      v-for="(plaats, index) in $v.contact.verblijfplaats.$each.$iter"
      :key="'vp-' + index"
      v-model="contact.verblijfplaats[index]"
      :id="'verblijfplaats-' + index"
      :label="
        contact.verblijfplaats.length != 1
          ? labels.verblijfplaats.objectName.singular +
            ' ' +
            (parseInt(index) + 1)
          : labels.verblijfplaats.objectName.singular
      "
      class="mt-3"
      :is-dirty="
        isDiffToCache(
          contact.verblijfplaats[parseInt(index)],
          cache.verblijfplaats[parseInt(index)]
        )
      "
      :show-delete="index != 0"
      :is-new="index >= cache.verblijfplaats.length"
      :info="infoForInput('verblijfplaats')"
      :is-disabled="disabledFieldsMap.verblijfplaats"
      @delete-address="deleteVerblijfplaats(index)"
    >
    </address-input>
    <div class="text-center my-1 pb-3 border-bottom">
      <plus-button
        class="mr-1"
        v-if="hasMaxOneNew(contact.verblijfplaats, cache.verblijfplaats)"
        @click="addVerblijfplaats()"
        :disabled="disabledFieldsMap.verblijfplaats"
        :label="
          'Bij verhuis: ' +
            labels.verblijfplaats.objectName.singular.toLowerCase() +
            ' toevoegen'
        "
      >
      </plus-button>
      <plus-button
        v-if="
          isWoonplaatsVerhuisAdded &&
            hasMaxOneNew(contact.verblijfplaats, cache.verblijfplaats)
        "
        @click="contact.verblijfplaats.push(contact.woonplaats[1])"
        :disabled="disabledFieldsMap.verblijfplaats"
        :label="
          'Nieuwe ' +
            labels.woonplaats.objectName.singular.toLowerCase() +
            ' overnemen'
        "
      >
      </plus-button>
    </div>

    <address-input
      v-for="(plaats, index) in $v.contact.correspondentie.$each.$iter"
      :key="'corr-' + index"
      v-model="contact.correspondentie[index]"
      :id="'correspondentie-' + index"
      :label="
        contact.correspondentie.length != 1
          ? labels.correspondentie.objectName.singular +
            ' ' +
            (parseInt(index) + 1)
          : labels.correspondentie.objectName.singular
      "
      class="mt-3"
      :is-dirty="
        isDiffToCache(
          contact.correspondentie[parseInt(index)],
          cache.correspondentie[parseInt(index)]
        )
      "
      :show-delete="index != 0"
      :is-new="index >= cache.correspondentie.length"
      :info="infoForInput('correspondentie')"
      :is-disabled="disabledFieldsMap.correspondentie"
      @delete-address="deleteCorrespondentie(index)"
    >
    </address-input>
    <div class="text-center my-1 pb-3 border-bottom">
      <plus-button
        class="mr-1"
        v-if="hasMaxOneNew(contact.correspondentie, cache.correspondentie)"
        @click="addCorrespondentie()"
        :disabled="disabledFieldsMap.correspondentie"
        :label="
          'Bij verhuis: ' +
            labels.correspondentie.objectName.singular.toLowerCase() +
            ' toevoegen'
        "
      >
      </plus-button>
      <plus-button
        v-if="
          isWoonplaatsVerhuisAdded &&
            hasMaxOneNew(contact.correspondentie, cache.correspondentie)
        "
        @click="contact.correspondentie.push(contact.woonplaats[1])"
        :disabled="disabledFieldsMap.correspondentie"
        :label="
          'Nieuwe ' +
            labels.woonplaats.objectName.singular.toLowerCase() +
            ' overnemen'
        "
      >
      </plus-button>
    </div>
    
    <phone-input
      v-for="(nummer, index) in $v.contact.comnummer.$each.$iter"
      v-model="contact.comnummer[index]"
      :key="'PhoneNr-' + index"
      :id="'nr-' + index"
      :label="
        contact.comnummer.length != 1
          ? labels.comnummer.objectName.singular + ' ' + (parseInt(index) + 1)
          : labels.comnummer.objectName.singular
      "
      :is-new="index >= cache.comnummer.length"
      :is-dirty="
        isDiffToCache(
          contact.comnummer[parseInt(index)],
          cache.comnummer[index]
        )
      "
      :info="infoForInput('comnummer')"
      :show-delete="contact.comnummer.length > 1"
      :is-disabled="disabledFieldsMap.comnummer"
      class="mt-3"
      @delete-phone="deleteTelefoonNummer(index)"
    >
    </phone-input>
    <div class="text-center my-3 pb-3 border-bottom">
      <plus-button
        @click="addTelefoonNummer()"
        label="Telefoon-, GSM- of noodnummer toevoegen"
        :disabled="disabledFieldsMap.comnummer"
      >
      </plus-button>
    </div>

    <mail-input
      v-for="(email, index) in $v.contact.email.$each.$iter"
      :key="index"
      v-model="contact.email[index].emailAdres"
      :id="'pLidEmail' + index"
      :label="
        contact.email.length != 1
          ? labels.email.objectName.singular + ' ' + (parseInt(index) + 1)
          : labels.email.objectName.singular
      "
      class="mt-3"
      :is-dirty="
        isDiffToCache(
          contact.email[parseInt(index)],
          cache.email[parseInt(index)]
        )
      "
      :is-new="parseInt(index) >= cache.email.length"
      :show-delete="index != 0"
      :info="infoForInput('email')"
      :is-disabled="disabledFieldsMap.email"
      @delete-mail="deleteEmail(index)"
    >
    </mail-input>
    <div class="text-center my-2">
      <plus-button
        @click="addEmail()"
        :disabled="disabledFieldsMap.email"
        label="E-mailadres toevoegen"
      >
      </plus-button>
    </div>
    <div class="pt-3 mt-3 border-top">
      <text-input
        v-for="(email, index) in $v.contact.werkEmail.$each.$iter"
        v-model="contact.werkEmail[index].emailAdres"
        :id="'werkEmail-' + index"
        :key="'werkEmail-' + index"
        :label="
          contact.werkEmail.length != 1
            ? labels.werkEmail.objectName.singular + ' ' + (parseInt(index) + 1)
            : labels.werkEmail.objectName.singular
        "
        :validation-object="$v.contact.werkEmail"
        :info="infoForInput('werkEmail')"
        :is-dirty="false"
        :is-disabled="disabledFieldsMap.werkEmail"
      >
      </text-input>
    </div>

    <div class="pt-2 mt-3 border-top">
      <label class="font-weight-bold">Opmerking:</label>
      <textarea
        @input="onRemarkChange"
        v-model="currentRemark"
        rows="3"
        class="form-control mb-2"
        placeholder="Opmerking"
        type="text"
      ></textarea>
    </div>
    <file-upload
      label="Bewijsstuk(ken) uploaden:"
      :upload-percentage="0"
      @files-changed="onFilesChanged"
    ></file-upload>
  </div>
</template>

<script>
import diff from "deep-diff";
import DossierLabels from "./../DossierLabels.js";
import {
  maxLength,
  email,
  required,
  requiredIf,
} from "vuelidate/lib/validators";
import {
  proofSuppliedIfNeeded,
} from "../../utils/DossierUtils.js";
import AddressInput from "./../../inputs/AddressInput.vue";
import PhoneInput from "./../../inputs/PhoneInput.vue";
import MailInput from "./../../inputs/MailInput.vue";
import PlusButton from "./../../interface/PlusButton.vue";
import FileUpload from "./../../inputs/FileUpload.vue";
import TextInput from "./../../inputs/TextInput.vue";

export default {
  name: "contact-form",
  props: {
    contact: {
      type: Object,
    },
    cache: {
      type: Object,
    },
    remark: {
      type: String,
    },
    attachments: {
      type: Array,
      required: false,
    },
    disabledFieldsMap: {
      type: Object,
    },
    proofRequiredFieldsMap: {
      type: Object,
    },
    proofInfoFieldsMap: {
      type: Object,
    },
  },
  components: {
    AddressInput,
    PhoneInput,
    MailInput,
    PlusButton,
    FileUpload,
    TextInput,
  },
  data() {
    return {
      labels: DossierLabels.contact,
      currentAttachments: this.attachments,
      currentRemark: this.remark,
    };
  },
  created() {
    this.$emit("validation-change", false);
  },
  computed: {
    doesFormRequireProof() {
      return Object.values(this.proofRequiredFieldsMap).indexOf(true) > -1;
    },
    canAddWerkEmail() {
      return this.contact.werkEmail.length < 2;
    },
    isWoonplaatsVerhuisAdded() {
      return this.contact.woonplaats.length == 2;
    },
  },
  methods: {
    addWoonplaats() {
      this.contact.woonplaats.push({
        id: 0,
        land: { land: "België", landCode: "00150"},
        ingangsdatum: null,
        bus: "",
        nr: "",
        deelgemeente: "",
        hfdPostnr: "",
        straat: "",
      });
    },
    addVerblijfplaats() {
      this.contact.verblijfplaats.push({
        id: 0,
        land: { land: "België", landCode: "00150"},
        ingangsdatum: null,
        bus: "",
        nr: "",
        deelgemeente: "",
        hfdPostnr: "",
        straat: "",
      });
    },
    addCorrespondentie() {
      this.contact.correspondentie.push({
        id: 0,
        land: { land: "België", landCode: "00150"},
        ingangsdatum: null,
        bus: "",
        nr: "",
        deelgemeente: "",
        hfdPostnr: "",
        straat: "",
      });
    },
    addEmail() {
      this.contact.email.push({ id: 0, emailAdres: "" });
    },
    addTelefoonNummer() {
      this.contact.comnummer.push({
        id: 0,
        prefix: "+ 32",
        nummer: "",
        type: "Mobiel",
        soort: "Telefoon",
        opm: ""
      });
    },
    deleteWoonplaats(index) {
      this.contact.woonplaats.splice(index, 1);
    },
    deleteVerblijfplaats(index) {
      this.contact.verblijfplaats.splice(index, 1);
    },
    deleteCorrespondentie(index) {
      this.contact.correspondentie.splice(index, 1);
    },
    deleteEmail(index) {
      this.contact.email.splice(index, 1);
    },
    deleteTelefoonNummer(index) {
      if (this.contact.comnummer[index].id != 0) {
        this.contact.comnummer[index].nummer = "";
        this.contact.comnummer[index].opm = "";
        return;
      }
      this.contact.comnummer.splice(index, 1);
    },
    hasMaxOneNew(currentArray, cacheArray) {
      return currentArray.length - cacheArray.length < 1;
    },
    isDiffToCache(newValue, cachedValue) {
      let parsedValue = JSON.parse(JSON.stringify(newValue));
      return diff(cachedValue, parsedValue) != undefined;
    },
    onFilesChanged(value) {
      this.currentAttachments = value;
      this.$emit("files-changed", this.currentAttachments);
    },
    onRemarkChange() {
      this.$emit("remark-changed", this.currentRemark);
    },
    isFieldUpdated(fieldName) {
      let parsedValue = JSON.parse(JSON.stringify(this.contact[fieldName]));
      return this.isDiffToCache(parsedValue, this.cache[fieldName]);
    },
    infoForInput(valueName) {
      if (this.proofRequiredFieldsMap[valueName]) {
        if (this.proofInfoFieldsMap[valueName] != "") {
          return this.proofInfoFieldsMap[valueName];
        }
        return "Bewijsstuk vereist om dit veld aan te passen.";
      } else {
        return null;
      }
    },
  },
  validations() {
    return {
      contact: {
        woonplaats: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.woonplaats,
              this.isFieldUpdated("woonplaats"),
              this.currentAttachments
            ),
            straat: {
              maxLength: maxLength(50),
            },
            nr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            bus: {},
            hfdPostnr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            deelgemeente: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            land: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
          },
        },
        verblijfplaats: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.verblijfplaats,
              this.isFieldUpdated("verblijfplaats"),
              this.currentAttachments
            ),
            straat: {
              maxLength: maxLength(50),
            },
            nr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            bus: {},
            hfdPostnr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            deelgemeente: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            land: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
          },
        },
        correspondentie: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.correspondentie,
              this.isFieldUpdated("correspondentie"),
              this.currentAttachments
            ),
            straat: {
              maxLength: maxLength(50),
            },
            nr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            bus: {},
            hfdPostnr: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            deelgemeente: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
            land: {
              requiredIf: requiredIf((object) => {
                return object.straat !== "";
              }),
            },
          },
        },
        comnummer: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.comnummer,
              this.isFieldUpdated("comnummer"),
              this.currentAttachments
            ),
            prefix: {
              maxLength: maxLength(5),
            },
            nummer: {
              maxLength: maxLength(20),
            },
            type: {
              required,
            },
            soort: {
              required,
            },
            opm: {
              requiredIf: requiredIf((cnr) => {
                return cnr.nummer != "" && cnr.type == "Noodnummer";
              }),
            }
          },
        },
        email: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.email,
              this.isFieldUpdated("email"),
              this.currentAttachments
            ),
            emailAdres: {
              email,
              required,
            },
          },
        },
        werkEmail: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.werkEmail,
              this.isFieldUpdated("werkEmail"),
              this.currentAttachments
            ),
            emailAdres: {
              email,
              required,
            },
          },
        },
      },
    };
  },
  watch: {
    $v: {
      handler(value) {
        this.$emit("validation-change", value.$invalid);
      },
      deep: true,
    },
  },
};
</script>
